import { useState, useEffect } from 'react';
import { getTranslation, Translation } from '../i18n/translations';

export const useTranslation = (currentLanguage: string) => {
  const [language, setLanguage] = useState(currentLanguage);
  
  // 当currentLanguage改变时更新内部状态
  useEffect(() => {
    setLanguage(currentLanguage);
  }, [currentLanguage]);
  
  const t = (key: keyof Translation): string => {
    return getTranslation(language, key);
  };

  return { t };
}; 